import Log from "./Log";
import { withRouter } from "react-router-dom";

export default withRouter(Log);
